import Vue from 'vue'
import Router from 'vue-router'
import lingo_user_profile from '../components/UserProfile'
import lingo_gallery from '../components/Gallery'
import lingo_favorites from '../components/Favorites'
import lingo_pricing from '../components/Pricing'
import lingo_audio_generator from '../components/AudioGenerator'
import lingo_video_generator from '../components/VideoGenerator'
import lingo_my_files from '../components/MyFiles'
import logoutCallback from '../components/auth/LogoutCallback'
import loginCallback from '../components/auth/LoginCallback'
import welcomepage from '../components/welcomepage/WelcomePage'
import mainscreen from '../components/MainScreen'
import privacyPolicy from '../components/PrivacyPolicy'
import cookiePolicy from '../components/CookiePolicy'
import termsOfUse from '../components/TermsOfUse'
import euProgramDetails from '../components/ProgramDetails'
import audio_test from '../components/AudioTest'
import not_found_component from '../components/NotFoundComponent'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'WelcomePage',
      component: welcomepage
    },
    {
      path: '/login',
      name: 'loginCallback',
      component: loginCallback
    },
    {
      path: '/logout',
      name: 'logoutCallback',
      component: logoutCallback
    },
    {
        path: '/legal',
        name: 'privacyPolicy',
        component: privacyPolicy
    },
    {
        path: '/cookiePolicy',
        name: 'cookiePolicy',
        component: cookiePolicy
    },
    {
        path: '/terms',
        name: 'termsOfUse',
        component: termsOfUse
    },
    {
        path: '/programInfo',
        name: 'euProgramDetails',
        component: euProgramDetails
    },
    {
      path: '/app',
      name: 'MainScreen',
      component: mainscreen,
      children: [
        {
          path: 'gallery',
          name: 'Voice Samples',
          component: lingo_gallery
        },
        {
            path: 'favorites',
            name: 'Favorite Voices',
            component: lingo_favorites
          },
        {
            path: 'pricing',
            name: 'Pricing Plans',
            component: lingo_pricing
         },
         {
             path: 'profile',
             name: 'My Profile',
             component: lingo_user_profile
        },
        {
          path: 'audio_generator',
          name: 'Audio Generator',
          component: lingo_audio_generator
        },
        {
          path: 'video_generator',
          name: '',
          component: lingo_video_generator
        },
        {
            path: 'my_files',
            name: 'My Files',
            component: lingo_my_files
         },
        {
          path: 'audio_test',
          name: '',
          component: audio_test
        }
      ]
    },
    {
      path: '*',
      name: 'NotFoundComponent',
      component: not_found_component
    }
  ]
})
